import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDCardContent,
  FDPaper,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { AccordionCategoryList } from 'Components/ComponentLibrary/Organisms/AccordionCategoryList';
import { CashFlowItem } from 'Views/Page/Content/Templates/CashFlowMDCPageTemplate/CashFlowItem';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const CashFlowCategorySection = ({
  sectionResource,
  onEditItemClick,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const onEditCategoryClick = (rel) => () => loadModalCollectionByLink(rel.link('related').url());

  return (
    <FDPaper maxWidth={'500px'} width={'100%'}>
      <FDBox paddingX={2} paddingY={1}>
        <FDStack justifyContent={'space-between'}>
          <FDTitleText value={sectionResource.selectedOptionPrompt('sectionName')} />
          <FDTitleText value={sectionResource.attr('total')} data-test={`${sectionResource.attr('sectionName')}-total`} />
        </FDStack>
      </FDBox>
      <FDCardContent>
        <AccordionCategoryList
          ListItemComponent={CashFlowItem}
          onEditCategoryClick={onEditCategoryClick}
          categoriesCollection={sectionResource.attr('categories')}
          onEditLineItemClick={onEditItemClick}
          emptyTitle={sectionResource.attr('emptyStateHeader')}
          emptyDescription={`Add your ${sectionResource.selectedOptionPrompt('sectionName').toLowerCase()} to start seeing your full financial picture.`}
        />
      </FDCardContent>
    </FDPaper>
  );
};

CashFlowCategorySection.propTypes = {
  sectionResource: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func.isRequired,
};
